import React, { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { selectorFamily, useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil"
//import { menuIdSelectedState, menuLivelliSelector, titles } from "../atoms/menu"
import { contextSelector } from "../atoms/portale"
import { deleteServiceSelector, serviceAtom, serviceFilterAtom, serviceListAtom } from "../atoms/serviceDescriptor"
import { ServiceDescriptor } from "../models/ServiceDescriptor"
import { AmbienteSelector, ProvinciaSelector } from "../models/UserContext"
import apiService from "../services/api"
import { InfoCircle } from "../svgicons/InfoCircle"
import { useLocationBase } from "../utils/hooks"
import SearchIcon from "@mui/icons-material/Search"
import { Autocomplete, AutocompleteChangeReason, AutocompleteRenderInputParams, Box, Fab, TableCell, TableContainer, TablePagination, TextField, Typography } from "@mui/material"
import TableView from "../framework/ui/view/table"
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import { useTranslation } from "react-i18next"
import excerpts from "../utils/excerpts"
import { Label } from "@mui/icons-material"
import { currentServicePage } from "../atoms/paging"


const ServiceDescriptorSearch = () => {
    //const openDrawer = useRecoilValue(openDrawerState)
    const [, setServiceD] = useRecoilState(serviceAtom)
    const serviceDefault = useResetRecoilState(serviceAtom)
    const userCtxSel = useRecoilValue(contextSelector)
    const base = useLocationBase()
    //const match = useRouteMatch()
    const applHrefRef = useRef<HTMLAnchorElement>(null)
    const [serviceFilter, setServiceFilter] = useRecoilState(serviceFilterAtom)
    const navigate = useNavigate();
    const [provSel, setProvSel] = useState(userCtxSel.province[0])
    const [ambiSel, setAmbiSel] = useState(provSel.ambienti[0])
    const [ambientiUser, setAmbientiUser] = useState<AmbienteSelector[]>(provSel.ambienti)
    const [description, setDescription] = useState('')
    const [provUser, setProvUser] = useState<ProvinciaSelector[]>(userCtxSel.province)
    const [servizi, setServizi] = useRecoilState<ServiceDescriptor[]>(serviceListAtom)
    const setDeleteFromLista = useSetRecoilState(deleteServiceSelector)
    const {t} = useTranslation()
    const [page, setPage] = useState<number>(0);
    let rowsPerPage: number = 10;
    const [currentPage, setCurrentPage] = useRecoilState<number>(currentServicePage);
    //const [totalCount, setTotalCount] = useState<number>(0)

    const handleEdit = (item: ServiceDescriptor) => (ev: React.MouseEvent<HTMLTableCellElement>) => {
        apiService.getServiceDesciptor(item.id).then(result => {
            if (result) {
                saveFilter()
                setServiceD(result);
                setCurrentPage(page)
                console.log('item Search', result)
                let path: string = `/adm/servicedescriptor/${item.id}`;
                navigate(path);
            }
        })
    }

    const handleAdd = (ev: React.MouseEvent<HTMLButtonElement>) => {
        const newId = 0;
        console.log('Handle Add')
        serviceDefault()
        saveFilter()
        setCurrentPage(page)
        let path: string = `/adm/servicedescriptor/${newId}`
        console.log('path', path)
        navigate(path);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleDelete = (item: ServiceDescriptor) => (ev: React.MouseEvent<HTMLTableCellElement>) => {
        // eslint-disable-next-line no-restricted-globals        
        if (confirm('Confermi eliminazione elemento') === true) {
            apiService.deleteServiceDescriptor(item.id).then(result => {
                if (result) {
                    serviceDefault();
                    //handleSearch()
                    setDeleteFromLista(item)
                }
            })
        }
    }

    const searchQuery = () => {
        apiService.getServiceDesciptorSearch(description, provSel.codice, ambiSel.value, 0/*, page, rowsPerPage*/)
            .then(result => {
                console.log('result search length', result)
                //setTotalCount(result && result.count ? result?.count : 0)
                setServizi(result ? result : []);
        })
    }

    const handleSearch = () => {
        console.log('filter', serviceFilter)
        setPage(0)

        searchQuery()
    }

    // const handleProvChangeSelect = (v: ProvinciaSelector | null) => {
    //     if (!v) return;
    //     handleProvChangeInternal(v.value)
    // }
    
    const handleProvChangeInternal = (value: string) => {
        console.log(`handleProvChangeSelect: value selected is ${value}`)
        const ambiCodice = ambiSel.codice
        // const p = userCtxSel.province.find(x => x.codice === value)
        const p = provUser.find(x => x.codice === value)
        if (!p) return;
        setProvSel(p);
        let a = ambientiUser.find(x => x.codice === ambiCodice)
        // if (!a) { a = p.ambienti[0] }
        if (!a) { a = ambientiUser[0] }
        if (a) {
            setAmbiSel(a)
        }
        console.log(`handleProvChange: `, value)
    }

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage)
        //searchQuery()
    };
    
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        rowsPerPage = parseInt(event.target.value, 10);
        setPage(0);
    };
    
    const saveFilter = () => {
        setServiceFilter({...serviceFilter, description: description, ambiente: ambiSel.value, provincia: provSel.value})
    }

    const getDescrizioneProvincia = (o: ProvinciaSelector) => {
        // case 'full': return `${o.codice} - ${o.descrizione}`
        // case 'codice': return o.codice
        // case 'descrizione':
        // return `${o.codice} - ${o.descrizione}`
        return o.descrizione
    }
    
    useEffect(() => {
        setPage(currentPage);
        //searchQuery()

        //Get the data from Service descriptor
        let myProvince: ProvinciaSelector[] = [];
        myProvince.push({label: 'Tutte', value: '', codice: '', descrizione: 'Tutte', ambienti: []})
        setProvUser([...myProvince, ...provUser])
        setAmbientiUser(provSel.ambienti)
        console.log('ambientiUsr at begin', ambientiUser)
        let myAmbienti: AmbienteSelector[] = [];
        myAmbienti.push({label: 'Tutte', value: '', codice: '', descrizione: 'Tutte', uffici: []})
        setAmbientiUser([...myAmbienti, ...ambientiUser])
        console.log('ambientiUsr at end useEffect', ambientiUser)

        //Imposto il filtro al ritorno
        //console.log('filter read', serviceFilter)
        setDescription(serviceFilter.description ? serviceFilter.description : '')
        const p = provUser.find(x => x.codice === serviceFilter.provincia)
        if (p)
            setProvSel(p)
        else 
            setProvSel({value: '', codice: '', label: 'Tutte', descrizione: 'Tutte', ambienti: []})
        
        let a = ambientiUser.find(x => x.codice === serviceFilter.ambiente)
        if (a)
            setAmbiSel(a)
        else 
            setAmbiSel({value: '', codice: '', label: 'Tutte', descrizione: 'Tutte', uffici: []})            
        }, 
    // Dipendenza da valutare
    // eslint-disable-next-line    
    [])

    return (
    <Box sx={{display: 'flex', flexDirection: 'column'}}>
        <Box sx={{display: 'flex', px: 2, gap: 2, pt: 1 }}>
            <Box sx={{display: 'flex', alignItems: 'center'}}>
                <Typography variant="body2">Filtri</Typography>
            </Box>
            <Box>
                <TextField
                    sx={{minWidth: '300px'}} 
                    id="idDescrizione" 
                    placeholder="Filtro note & info" 
                    value={description} 
                    onChange={event => setDescription(event.target.value)} 
                    size="small"
                    fullWidth
                />
            </Box>
            <Box>
                <Autocomplete 
                    id="provincia"
                    //multiple={true}
                    filterSelectedOptions
                    options={provUser} 
                    value={provSel} 
                    getOptionLabel={getDescrizioneProvincia}
                    //onChange={handleProvChangeSelect} 
                    onChange={(event: React.SyntheticEvent<Element, Event>, value: ProvinciaSelector | null, reason: AutocompleteChangeReason) => {
                        console.log({reason})
                        console.log({value})
                        if (value)
                            handleProvChangeInternal(value.codice)
                        //const result = value ? value.reduce((p, x) => `${p}${x.area};`, '') : ''
                        // console.log('result for aree', result?.toString().replace(',', ''))
                        //setFieldValue("aree", result?.toString().replace(',', ''));
                    }}
                    renderInput={(params: AutocompleteRenderInputParams) => (
                        <TextField
                            sx={{minWidth: '200px'}}
                            {...params}
                            name="provincia"
                            variant="outlined"
                            fullWidth
                            size='small'
                        />
                    )}
                />
            </Box>
            <Box>
                <Autocomplete 
                    id="ambiti"
                    //multiple={true}
                    filterSelectedOptions
                    options={ambientiUser} 
                    value={ambiSel} 
                    onChange={(event: React.SyntheticEvent<Element, Event>, value: AmbienteSelector | null, reason: AutocompleteChangeReason) => {
                        if (!value) return
                        let a = ambientiUser.find(x => x.codice === value.codice)
                        if (a) {
                            setAmbiSel(a)
                        }                    
                    }}
                    renderInput={params => (
                        <TextField
                            {...params}
                            sx={{minWidth: '150px'}}
                            name="ambito"
                            variant="outlined"
                            fullWidth
                            size='small'
                        />
                    )}
                />
            </Box>
            <Box>
                <Fab size="small" color="primary" onClick={handleSearch}><SearchIcon /></Fab>
                {/* <div className="btn" onClick={() => handleSearch()} style={{ marginLeft: '30%' }}><SearchIcon /></div> */}
            </Box>
        </Box>
        <Box sx={{ mb: 1, mt: 1, px: 2, pt: 1 }}>
            <TableContainer sx={{position: 'relative'}}>
                <Fab size="small" color="primary" sx={{ position: 'absolute', top: 8, right: 8, zIndex: 3 }} onClick={handleAdd}><AddIcon /></Fab>
                <TableView
                    items={servizi.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
                    itemKey={(item: ServiceDescriptor) => item.id}
                    //pageLoader={}
                    thDefs={<>
                        <TableCell><Typography color='primary'>{t('Ambiente')}</Typography></TableCell>
                        <TableCell><Typography color='primary'>{t('Descrizione url')}</Typography></TableCell>
                        <TableCell><Typography color='primary'>{t('Area')}</Typography></TableCell>
                        <TableCell><Typography color='primary'>{t('Province')}</Typography></TableCell>
                        <TableCell><Typography color='primary'>{t('Note')}</Typography></TableCell>
                        <TableCell><Typography color='primary'>{t('Info')}</Typography></TableCell>
                        <TableCell><Typography color='primary'>{t('Livello')}</Typography></TableCell>
                        <TableCell >
                            <Typography color='primary'>{t('Azioni')}</Typography>
                        </TableCell>
                    </>}
                    trDefs={(row: ServiceDescriptor) => (<>
                        <TableCell>{row.ambiente}</TableCell>
                        <TableCell>{row.urlDescription}</TableCell>
                        <TableCell>{row.area}</TableCell>
                        <TableCell>{row.perProvince}</TableCell>
                        <TableCell sx={{minWidth: '400px'}}>{row.note}</TableCell>
                        <TableCell style={{maxWidth: '450px'}}>{excerpts(row.info ? row.info : '', { words: 40 })}</TableCell>
                        <TableCell>{row.livello}</TableCell>
                        <TableCell >
                            <Box sx={{display: 'flex', gap: 0.5, cursor: 'pointer', textAlign: 'center', height: '100%', pt: '6px', pb: 0}}>
                                <Box onClick={handleDelete(row)} sx={{width: 20, height: 20}}> 
                                    <DeleteIcon fontSize='small' titleAccess={t('Elimina')} color='primary' />
                                </Box>
                                <Box onClick={handleEdit(row)} sx={{width: 20, height: 20}}> 
                                    <EditIcon fontSize='small' titleAccess={t('Modifica')} color='primary' />
                                </Box>
                            </Box>
                        </TableCell>
                    </>)}
                />
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={servizi.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />            
        </Box>        
    </Box>
    )
}

export default ServiceDescriptorSearch
